<template>
    <div>
        <fieldset>
            <div>
                <h3>{{ trans('registrant_details') }}</h3>
            </div>
            <div class="form-body">
                <txt v-model="model.entityname" label="entity_name"></txt>
                <div class="split-fields">
                    <list v-model="model.entityidtype" label="ID Type" :list="['ABN', 'ACN', 'BRN']"></list>
                    <txt v-model="model.entityid" label="ID Value"></txt>
                </div>
                <div class="split-fields">
                    <list v-if="model.entityidtype == 'ABN'" v-model="model.abntype" label="ABN Type" :list="['Company','Registered Business','Partnership','Sole Trader','Incorporated Association','Commercial Statutory Body','Other']"></list>
                    <list v-if="model.entityidtype == 'BRN'" v-model="model.brntype" label="BRN Type" :list="['ACT','NSW','NT','QLD','SA','TAS','VIC','WA']"></list>
                </div>
            </div><!-- .form-body -->
        </fieldset>

        <!-- Contact Fields -->
        <fieldset>
            <h3 class="form-heading">Registrant Contact</h3>
            <div class="form-body">
                <domain-contact name="registrant" v-model="model.registrantContact"></domain-contact>
            </div><!-- .form-body -->
        </fieldset>
        <fieldset>
            <div class="form-heading small">
                <h3>Admin Contact</h3>
                <div class="css-checkbox accordian">
                    <label data-toggle="collapse" data-target="#admin-contact">
                        <input type="checkbox"  v-model="model.adminCopy">Same as Registrant Contact
                    </label>
                </div>
            </div>
            <div id="admin-contact" class="collapse">
                <domain-contact name="admin" v-model="model.adminContact"></domain-contact>
            </div>
        </fieldset>
        <fieldset>
            <div class="form-heading small">
                <h3>Billing Contact</h3>
                <div class="css-checkbox accordian">
                    <label data-toggle="collapse" data-target="#billing-contact">
                        <input type="checkbox" v-model="model.billCopy">Same as Registrant Contact
                    </label>
                </div>
            </div>
            <div id="billing-contact" class="collapse">
                <domain-contact name="billing" v-model="model.billingContact"></domain-contact>
            </div>
        </fieldset>
        <fieldset>
            <div class="form-heading small">
                <h3>Tech Contact</h3>
                <div class="css-checkbox accordian">
                    <label data-toggle="collapse" data-target="#tech-contact">
                        <input type="checkbox" v-model="model.techCopy">Same as Registrant Contact
                    </label>
                </div>
            </div>
            <div id="tech-contact" class="collapse">
                <domain-contact name="tech" v-model="model.techContact"></domain-contact>
            </div>
        </fieldset>

        <div class="section">
            <button class="btn btn-filled" v-on:click.prevent="registerDomain">Register Domain</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: { default : '' },
            domain: { default : {
                address:'',
                tld:''
            } }
        },
        data: function() {
            return {
                model: {
                    adminCopy: true,
                    billCopy: true,
                    techCopy: true,
                    registrantContact: {},
                    adminContact: {},
                    billingContact: {},
                    techContact: {},
                    entityname: '',
                    entityid: '',
                    entityidtype: 'ABN',
                    abntype: 'Registered Business',
                    btntype: 'QLD'
                }
            }
        },
        created() {
            this.$eventHub.$on('setRegister', this.setRegister);
        },
        components: {
            'list': require('../../components/form/list.vue').default,
            'domain-contact': require('../../components/domain-contact.vue').default
        },
        methods: {
            setRegister(data) {
                this.model.entityname = (typeof data.entityname !== 'undefined') ? data.entityname : '';
                this.model.entityid = (typeof data.entityid !== 'undefined') ? data.entityid : '';
            },
            registerDomain: function () {
                this.model.address = this.domain.address;
                this.model.tld = this.domain.tld;
                Swal.fire({
                    title: 'Are you sure?',
                    text: "This will charge your account $xx.xx for the domain registration.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#46c37b',
                    cancelButtonColor: '#00ADD3',
                    confirmButtonText: 'Register Domain!',
                }).then(function () {
                    this.$store('/api/domain/register', this);
                }.bind(this));
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('setRegister', this.setRegister);
        }
    }
</script>
